import React from 'react';
import styles from './Footer.module.scss';

export const Footer = () => {
  return (
    <div className={styles.footer}>
      <a className={styles.link} href='https://github.com/RockStar666by'>
        Github: RockStar666by
      </a>
    </div>
  );
};
